import React from 'react';

export interface PageProps {
  children: React.ReactNode;
  documentTitle?: string;
  documentDescription?: string;
}

export function Page({ children }: PageProps) {
  return <>{ children }</>;
}
